import { Box, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { GridCloseIcon } from '@mui/x-data-grid';

import { useState } from 'react';

import DatePicker from 'react-datepicker';

import { calendarIcon } from 'common/assets/images';
import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import { formatDateRange, ImgTagComponent } from 'common/utils/utilFunctions';

import { DATE_RANGE_MODEL_CONSTANTS } from 'features/HorizonScanning/HorizonScanConstants';

import styles from './DateRangeModel.module.scss';

import 'react-datepicker/dist/react-datepicker.css';

interface IModelProps {
	openModal: boolean;
	handleClose: (type?: string) => void;
	handleSubmit: (dateRange: string) => void;
}
const sxBoxProps = {
	width: '37rem',
	height: '60rem',
	margin: 'auto',
	overflowX: 'unset',
	overflowY: 'unset',
};
const DateRangeModel = (props: IModelProps) => {
	const { HEADING, APPLY, CANCEL } = DATE_RANGE_MODEL_CONSTANTS;
	const [dueStartDate, setDueStartDate] = useState<any>();
	const [dueEndDate, setDueEndDate] = useState<any>();

	const { openModal, handleClose, handleSubmit } = props;
	const updateDateRange = () => {
		handleSubmit(
			`${formatDateRange(dueStartDate)}-${formatDateRange(dueEndDate)}`,
		);

		handleClose();
	};
	return (
		<ModalEle
			open={openModal}
			sxBoxProps={sxBoxProps}
			dataTestId="date-range-modal"
		>
			<Stack direction="column">
				<Stack direction="row" justifyContent="space-between">
					<Typography className={styles['header-text']} data-testid="header">
						{HEADING}
					</Typography>
					<GridCloseIcon
						onClick={() => handleClose('close')}
						className={styles['add-closemodal']}
						data-testid="close-icon"
					/>
				</Stack>
			</Stack>
			<Grid className={styles['range-date-picker-container']}>
				<Grid
					container
					mt={3}
					className={styles['range-date-picker-container-styles']}
				>
					<Grid item className={styles['range-date-picker']} mr={2}>
						<DatePicker
							selected={dueStartDate}
							onChange={(date) => {
								setDueStartDate(date);
							}}
							selectsStart
							startDate={dueStartDate}
							endDate={dueEndDate}
							maxDate={dueEndDate}
							dateFormat="MM/dd/yyyy"
							className="rasta-stripes"
							calendarClassName={styles['custom-datepicker']}
							wrapperClassName={styles.datePicker}
							placeholderText="MM/DD/YYYY"
							popperClassName={styles['range-date-picker-popper']}
							showIcon
							icon={ImgTagComponent(calendarIcon, 'calendarIcon')}
						/>
					</Grid>
					<Grid item className={styles['range-date-picker']}>
						<DatePicker
							selected={dueEndDate}
							onChange={(date) => {
								setDueEndDate(date);
							}}
							selectsEnd
							startDate={dueStartDate}
							endDate={dueEndDate}
							minDate={dueStartDate}
							dateFormat="MM/dd/yyyy"
							placeholderText="MM/DD/YYYY"
							popperClassName={styles['range-date-picker-popper']}
							showIcon
							icon={ImgTagComponent(calendarIcon, 'calendarIcon')}
						/>
					</Grid>
				</Grid>
			</Grid>
			<Box className={styles['btn-box']}>
				<Stack
					direction="row"
					justifyContent="flex-end"
					className={styles['btn-grp']}
				>
					<ButtonComp
						btnType="secondary"
						clickHandler={() => handleClose('close')}
						data-testid="cancel-btn"
					>
						{CANCEL}
					</ButtonComp>
					<ButtonComp
						btnType="primary"
						clickHandler={updateDateRange}
						disabled={!dueStartDate || !dueEndDate}
						data-testid="apply-btn"
					>
						{APPLY}
					</ButtonComp>
				</Stack>
			</Box>
		</ModalEle>
	);
};

export default DateRangeModel;
